import type { FC } from "react";
import {
  Column,
  ColumnHeader,
  ColumnItem,
  FooterBody,
  FooterHeader,
  FooterInner,
  LinkGroup,
  SocialContainer,
  StyledFooter,
} from "./footer.styles";
import { TextWrapper } from "../../pages/price-page/components/description/description.styles";
import { ReactComponent as Logo } from "@src/core/icons/logo.svg";
import { Container, ContentContainer } from "@src/core/styles";
import { Link } from "react-router-dom";

export const Footer: FC = () => {


  return (
    <StyledFooter>
      <Container>
        <ContentContainer>
          <FooterInner>
            <TextWrapper>
              <FooterHeader>
                <Logo />
                <LinkGroup>
                  <a href="/offers">Предложения</a>
                  <a href="/contacts">Контакты</a>
                  <a href="/offer">Помощь</a>
                  <a href="/legal_information">Правовая информация</a>
                </LinkGroup>
              </FooterHeader>
              <FooterBody>
                {/*<div>*/}
                {/*  Пользуясь нашим сервисом API, вы соглашаетесь с условиями и*/}
                {/*  положениями данного пользовательского соглашения. Вы*/}
                {/*  обязуетесь использовать API только в соответствии с*/}
                {/*  действующим законодательством и правилами использования*/}
                {/*  сервиса. Мы оставляем за собой право вносить изменения в API,*/}
                {/*  приостанавливать его работу или отказывать в доступе без*/}
                {/*  предварительного уведомления. Ваше использование API является*/}
                {/*  вашей ответственностью, и мы не несем ответственности за любой*/}
                {/*  ущерб, прямой или косвенный, возникший в результате*/}
                {/*  использования API.*/}
                {/*</div>*/}
                <div> &copy; 2023</div>
              </FooterBody>
            </TextWrapper>
            {/*<SocialContainer>*/}
            {/*  <Column>*/}
            {/*    <ColumnItem>*/}
            {/*      <ColumnHeader>Соцсети</ColumnHeader>*/}
            {/*    </ColumnItem>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>GitHub</ColumnItem>*/}
            {/*    </Link>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>YouTube</ColumnItem>*/}
            {/*    </Link>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>Telegram</ColumnItem>*/}
            {/*    </Link>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>Помощь</ColumnItem>*/}
            {/*    </Link>*/}
            {/*  </Column>*/}

            {/*  <Column>*/}
            {/*    <ColumnItem>*/}
            {/*      <ColumnHeader>Колонка</ColumnHeader>*/}
            {/*    </ColumnItem>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>Ссылка</ColumnItem>*/}
            {/*    </Link>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>Ссылка</ColumnItem>*/}
            {/*    </Link>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>Ссылка</ColumnItem>*/}
            {/*    </Link>*/}
            {/*    <Link to="#">*/}
            {/*      <ColumnItem>Ссылка</ColumnItem>*/}
            {/*    </Link>*/}
            {/*  </Column>*/}
            {/*</SocialContainer>*/}
          </FooterInner>
        </ContentContainer>
      </Container>
    </StyledFooter>
  );
};
